






































import Vue from 'vue';
import usuarioService from './usuario-service';
import Component from 'vue-class-component';
import Api from '../../base/api.typings';
import routerService from '../../base/router-service';
import env from '../../env/env';
import areaService from '../area-atual/area-service';
import { Prop } from 'vue-property-decorator';

@Component
export default class UsuarioListar extends Vue {

    @Prop() tipoEditar: number;

    tipoAba: number = null;

    usuarios: Api.App.Server.Usuario.Listar.UsuarioDto[] = null;

    abaAtiva: number = null;

    aba: number = 0;

    usuarioFoto: string = null;

    areaAtual: string = null;

    get tipo(): Api.Common.Infra.Auth.PerfilTipoUsuarioEnum {
        return this.aba + 1;
    };

    get carregando() { return !this.usuarios };

    private async listar() {
        let tipo = this.tipoAba;
        if (!tipo) {
            tipo = this.tipo;                
        }

        let usuarios = await usuarioService.listar({
            tipo: tipo
        });

        if (tipo) {
            this.tipoAba = null;
        }

        this.usuarios = usuarios.itens;

        this.usuarioFoto = `${env.apiAuthUrl}/api/Picture/GetPicture?userId=`; 
    }

    async editarUsuário(usuarioId: string) {
        await routerService.goTo('usuario-editar', { usuarioId });
    }

    obterAba() {
        this.tipoAba = this.tipoEditar;
        if (this.tipoAba) {
            this.aba = this.tipoAba - 1; 
        }
    }

    async created() {
        this.obterAba();
        this.areaAtual = await areaService.obterAreaPadrao();
        if (this.areaAtual == 'admin') {
            this.listar();
        }
    }
}
